import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SourceType } from '@siat-fe/core';
import { Observable } from 'rxjs';
import { GetRefreshToken, GetToken } from '../services/storage-data.utility';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const isRefreshCall = request.url.includes('refresh_token');
    const token = isRefreshCall ? GetRefreshToken() : GetToken();

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          Source: SourceType.WEB,
        },
      });
    } else {
      request = request.clone({
        setHeaders: {
          Source: SourceType.WEB,
        },
      });
    }

    return next.handle(request);
  }
}
